
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem6ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem6ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem6ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem6ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem6ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem6ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem6ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem6ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}